import * as React from "react";
const SvgFiRrPercent100 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-percent-100_svg__a)">
      <path
        fill="#062147"
        d="M2.878 5.771a1 1 0 0 1-.134-1.408A11.97 11.97 0 0 1 12 0c3.592 0 6.967 1.591 9.256 4.363a1 1 0 1 1-1.541 1.274A9.97 9.97 0 0 0 12 2a9.97 9.97 0 0 0-7.714 3.637 1 1 0 0 1-1.408.135zm16.836 12.592A9.97 9.97 0 0 1 12 22a9.97 9.97 0 0 1-7.714-3.637 1 1 0 1 0-1.542 1.273A11.97 11.97 0 0 0 12 23.999a11.97 11.97 0 0 0 9.256-4.363 1 1 0 1 0-1.543-1.273M7.5 8.019a2.5 2.5 0 0 1 2.5 2.5v3a2.5 2.5 0 1 1-5 0v-3a2.5 2.5 0 0 1 2.5-2.5m0 1.6c-.496 0-.9.404-.9.9v3c0 .496.404.9.9.9s.9-.404.9-.9v-3c0-.496-.404-.9-.9-.9m6-1.6a2.5 2.5 0 0 1 2.5 2.5v3a2.5 2.5 0 1 1-5 0v-3a2.5 2.5 0 0 1 2.5-2.5m0 1.6c-.496 0-.9.404-.9.9v3c0 .496.404.9.9.9.495 0 .9-.404.9-.9v-3c0-.496-.405-.9-.9-.9m9.25 3.881a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5M19.5 9.25a1.25 1.25 0 1 0-2.501 0 1.25 1.25 0 0 0 2.5 0M18.343 16a.8.8 0 0 0 .67-.363l4.179-6.4a.8.8 0 1 0-1.34-.874l-4.178 6.4a.8.8 0 0 0 .67 1.237M3.2 16.019a.8.8 0 0 0 .8-.8V8.862a.86.86 0 0 0-1.48-.599L.89 9.945a.8.8 0 1 0 1.15 1.113l.36-.372v4.532a.8.8 0 0 0 .8.801"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-percent-100_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPercent100;
